module.exports = __webpack_public_path__ + "static/media/visa-blue-creditCard.e3ab13ea.svg";